import _styled2 from "styled-components";
import _styled from "styled-components";
import React from 'react';
import { basicStyle, contentStyle } from './HScroll.style';
export const HScroll = _ref => {
  let {
    children,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(_StyledDiv, rest, /*#__PURE__*/React.createElement(_StyledDiv2, null, children));
};
export default HScroll;
var _StyledDiv = _styled("div").withConfig({
  displayName: "HScroll___StyledDiv",
  componentId: "sc-194g5cg-0"
})(["", ""], basicStyle);
var _StyledDiv2 = _styled("div").withConfig({
  displayName: "HScroll___StyledDiv2",
  componentId: "sc-194g5cg-1"
})(["", ""], contentStyle);
//# sourceMappingURL=HScroll.js.map